module.exports = __webpack_public_path__ + "tj.d070fa20775e8ff238c1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tj.svg
// module chunks = styles